import styled from "styled-components";

import { HelperText } from "../../../../../../common/components/HelperText/HelperText";

export const Helper = styled(HelperText)`
  margin-top: 1.2rem;
`;
